import {
  FETCH_MISSIONS,
  FetchMissionsBySchoolAndSchoolYearResponse,
  MissionsListQuery,
  MissionsListQueryVariables,
} from '@edwin-group/cj-graphql';
import { useMemo } from 'react';
import { useQueryCacheAndNetwork } from '@/hooks/useQueryCacheAndNetwork';
import { useAuthentication } from '@/hooks/useAuthentication';
import { buildMissionsQueryVariables, SearchFilters } from '../utils/query-variables';

export const useMissionsSearch = (filters: SearchFilters, shouldSkip: boolean) => {
  const { schoolContext } = useAuthentication();

  const queryVariables = useMemo(
    () => buildMissionsQueryVariables(filters, schoolContext?.documentId || ''),
    [filters, schoolContext?.documentId],
  );

  const {
    data: result,
    fetchMore,
    isInitialLoading,
    error,
  } = useQueryCacheAndNetwork<MissionsListQuery, MissionsListQueryVariables>(FETCH_MISSIONS, {
    variables: queryVariables as MissionsListQueryVariables,
    skip: shouldSkip,
  });

  const missionsList = result?.fetchMissionsBySchoolAndSchoolYear as FetchMissionsBySchoolAndSchoolYearResponse;

  return {
    missionsList,
    fetchMore,
    isLoading: isInitialLoading,
    error,
    queryVariables,
    result,
  };
};
